// Domain associé à un cours
import { z } from 'zod'

export const ReferentialDomainSchema = z.object({
  id: z.number(),
  title: z.string(),
  order: z.number(),
  tasks: z.array(z.any()).optional()
})

export const ReferentialDomainListSchema = z.array(ReferentialDomainSchema)

// Types dérivés des schemas
export type ReferentialDomainEntity = z.infer<typeof ReferentialDomainSchema>
export type ReferentialDomainListEntity = z.infer<typeof ReferentialDomainSchema>
